import URI from 'jsuri';

import config from 'js/app/config';

import PaymentProcessorTypes from 'bundles/payments/common/PaymentProcessorTypes';

type CreateOptions = {
  cartId: string;
  isPaymentUpdate: false;
  isSandboxEnabled: boolean;
};

type UpdateOptions = {
  isPaymentUpdate: true;
  isSandboxEnabled: boolean;
};

// Razorpay makes a POST request to this url with the response, so must be handled by a BE endpoint
export const getRazorpayCallbackUrl = (options: CreateOptions | UpdateOptions): string => {
  const paymentProcessorId = options.isSandboxEnabled
    ? PaymentProcessorTypes.razorpaySandbox
    : PaymentProcessorTypes.razorpay;
  const callbackType = options.isPaymentUpdate ? 'paymentMethodUpdatedResponse' : 'paymentResponse';

  const callbackUri = new URI(`${config.url.base}/payments/callbacks`)
    .addQueryParam('action', 'handlePaymentProcessorCallback')
    .addQueryParam('callbackType', callbackType)
    .addQueryParam('paymentProcessorId', paymentProcessorId);

  if ('cartId' in options) {
    callbackUri.addQueryParam('cartId', options.cartId);
  }

  return callbackUri.toString();
};
